import { useState } from "react";
import { Link } from "@tanstack/react-router";
import { CheckArea } from "@/components/zip-checker";
import { HomeMapFigure } from "@/components/home/map-preview";

/**
 * The opening spread: the question and the box that answers it on the left, the map
 * that is the answer for everyone else on the right. No gradient mesh, no grid
 * texture, no check-marked trust badges: the map is the picture, and it is real data.
 */
export function HomeHero() {
  // The search and the map are one figure: whatever the search answers, the map shows.
  const [answered, setAnswered] = useState<string | null>(null);
  return (
    <section className="border-b border-border">
      <div className="mx-auto grid max-w-6xl gap-x-14 gap-y-12 px-4 pb-14 pt-10 sm:px-6 sm:pt-16 lg:grid-cols-[1fr_1.05fr] lg:pb-20">
        <div className="max-w-xl">
          <p className="label-caps settle text-rust-ink">A field guide to the Lone Star tick</p>
          <h1 className="settle mt-4 font-display text-[2.6rem] font-medium leading-[1.02] tracking-[-0.025em] text-foreground sm:text-[3.6rem]">
            Are Lone Star ticks reported where you live?
          </h1>
          <p className="settle-2 mt-5 text-lg leading-relaxed text-pretty text-muted-foreground">
            Type your ZIP code, city or state. You&rsquo;ll see whether they live there, when
            they&rsquo;re active, and what to do if one bites you.
          </p>

          <div className="settle-3 mt-8">
            <CheckArea compact onAnswer={setAnswered} />
          </div>

          <p className="mt-6 text-xs leading-relaxed text-muted-foreground">
            Free, no signup. Built from CDC data and published research,{" "}
            <Link to="/sources" className="link">
              with every source listed
            </Link>
            . Not medical advice.
          </p>
        </div>

        <div className="settle-3 lg:pt-12">
          <HomeMapFigure highlight={answered} />
        </div>
      </div>
    </section>
  );
}
